import { useRouter } from "next/router";
import Stripe from "stripe";

import Pricing from "elements/Pricing";

import SectionShell from "components/Section-Shell";

import { Plan, getPlanDetails, getDefaultCouponDetails } from "lib/stripe";

interface Props {
  plans: Plan[];
  coupon: Stripe.Coupon | null;
}

const Page = ({ plans, coupon }: Props) => {
  const router = useRouter();

  const selectedPlan = router.query.plan as string;
  return (
    <SectionShell
      heading="SuperHeroes Start Here"
      subtitle="Choose your size. Doesnt fit? Change Anytime."
    >
      <Pricing
        plans={plans}
        selectedPlan={selectedPlan}
        coupon={coupon}
        showFAQs
      />
    </SectionShell>
  );
};

export default Page;

export async function getStaticProps() {
  const plans = await getPlanDetails();
  const coupon = await getDefaultCouponDetails();
  return { props: { plans, coupon } };
}
